import { Box, Typography } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import BulletFactoryPanels from "../../components/BulletFactoryPanels";
import BulletBalancePopup from "../../components/BulletFactoryPopup/BulletBalancePopup";
import BulletFactoryFailedPopup from "../../components/BulletFactoryPopup/BulletFactoryFailedPopup";
import BulletFactorySuccessPopup from "../../components/BulletFactoryPopup/BulletFactorySuccessPopup";
import { City } from "../../constants/const";
import useWallet from "../../hook/useWallet";
import {
  getBulletMarketLaunchBlockAction,
  getBulletMarketUpdateIntervalAction,
  getBusinessProfileAction,
  getNextBulletBuyTimeAction,
} from "../../reducers/game.slice";
import useBulletFactorySSE from "./hooks/useBulletFactorySSE";
import useStyles from "./index.styles";

const BulletFactory = () => {
  const { classes } = useStyles();
  const dispatch = useAppDispatch();
  const { account } = useWallet();
  const { myProfile } = useAppSelector((state) => state.profile);

  const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
  const [openFailedPopup, setOpenFailedPopup] = useState(false);
  const [openBalancePopup, setOpenBalancePopup] = useState(false);

  const [successCashAmount, setSuccessCashAmount] = useState(0);
  const [successBulletAmount, setSuccessBulletAmount] = useState(0);
  const [failedBulletAmount, setFailedBulletAmount] = useState(0);

  useEffect(() => {
    dispatch(
      getBusinessProfileAction({ itemId: 49, cityId: myProfile.city || 0 })
    );
  }, [myProfile.city, dispatch]);

  const onSuccess = useCallback((cashAmount: number, bulletAmount: number) => {
    setOpenSuccessPopup(true);
    setSuccessCashAmount(cashAmount);
    setSuccessBulletAmount(bulletAmount);
  }, []);

  const onFailed = useCallback((bulletAmount: number) => {
    setOpenFailedPopup(true);
    setFailedBulletAmount(bulletAmount);
  }, []);

  useBulletFactorySSE(account, onSuccess, onFailed, () => {});

  useEffect(() => {
    dispatch(getBulletMarketLaunchBlockAction());
    dispatch(getBulletMarketUpdateIntervalAction());
  }, [dispatch]);

  useEffect(() => {
    if (!account) return;

    dispatch(getNextBulletBuyTimeAction(account));
  }, [account, dispatch]);

  return (
    <Box className={classes.body}>
      <Box className={classes.container}>
        <Box className={classes.header}>
          <Box className={classes.headerLeft}>
            <Box className={classes.title}>
              <Typography
                fontFamily={"Philosopher"}
                color={"white"}
                textAlign={"center"}
                fontSize={36}
                fontWeight={700}
              >
                Bullet Factory
              </Typography>

              <Box
                component={"img"}
                src={"/assets/imgs/inventory/bulletitem.png"}
                alt="Bullet Image"
              />
            </Box>

            <Box className={classes.location}>
              <Typography
                fontFamily={"Philosopher"}
                color={"white"}
                textAlign={"center"}
                fontSize={16}
                fontWeight={900}
              >
                {myProfile.city !== undefined
                  ? City[myProfile.city]
                  : "Unknown"}
              </Typography>
            </Box>
          </Box>
        </Box>

        <BulletFactoryPanels setOpenBalancePopup={setOpenBalancePopup} />
      </Box>

      <BulletFactorySuccessPopup
        openModal={openSuccessPopup}
        setOpenModal={setOpenSuccessPopup}
        cashAmount={successCashAmount}
        bulletAmount={successBulletAmount}
      />

      <BulletFactoryFailedPopup
        openModal={openFailedPopup}
        setOpenModal={setOpenFailedPopup}
        failedBulletAmount={failedBulletAmount}
      />

      <BulletBalancePopup
        openModal={openBalancePopup}
        setOpenModal={setOpenBalancePopup}
      />
    </Box>
  );
};

export default BulletFactory;
